/**
 * Chess Square Component (Tailwind CSS)
 * Tailwind variant - uses Tailwind classes
 */
import type { SquareProps } from "../../types";
import { isLightSquare } from "../../utils";
import { PieceTailwind } from "../piece";
import { SquareBase } from "./SquareBase";

export function SquareTailwind(props: SquareProps) {
  const {
    file,
    rank,
    isSelected,
    isLegalMove,
    isCapture,
    isMyTurn,
    gameEnded,
  } = props;
  const isLight = isLightSquare(file, rank);

  const getBackgroundColor = (): string => {
    if (isSelected) return "var(--cn-chess-square-selected)";
    if (isCapture) return "var(--cn-chess-capture-ring)";
    if (isLegalMove) return "var(--cn-chess-move-dot)";
    return isLight
      ? "var(--cn-chess-square-light)"
      : "var(--cn-chess-square-dark)";
  };

  const cursorClass =
    isMyTurn !== undefined && gameEnded !== undefined
      ? isMyTurn && !gameEnded
        ? "cursor-pointer"
        : "cursor-default"
      : "cursor-pointer";

  const hoverClass =
    (isLegalMove || (isMyTurn && !gameEnded && props.piece)) &&
    "transition-all duration-150 hover:brightness-110";

  const containerClasses = `
    chess-square
    ${cursorClass}
    ${hoverClass || ""}
  `
    .trim()
    .replace(/\s+/g, " ");

  const legalMoveStyle: React.CSSProperties = {
    width: "2rem",
    height: "2rem",
    borderRadius: "9999px",
    border: "2px solid var(--cn-chess-move-dot)",
    backgroundColor: "var(--cn-chess-move-dot)",
    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
  };

  return (
    <SquareBase
      {...props}
      renderPiece={(piece) => piece && <PieceTailwind piece={piece} />}
      className={containerClasses}
      style={{ backgroundColor: getBackgroundColor() }}
      legalMoveStyle={legalMoveStyle}
    />
  );
}
